exports.list = {
    path: '/log',
    name: 'log', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/log/List.vue"),
}